import { Injectable } from "@angular/core";
import { RestApi } from "app/auth/rest.api";
import { Observable } from "rxjs";

@Injectable()
export class TableauService {
    tableauUrlServices = 'api/Tableau';
    constructor(private _http: RestApi) {}

    getTableuConfigurations() {
        return this._http.get(`${this.tableauUrlServices}/Tableau-configuration`);
    }


    saveTableauConfig(tableauConfiguration: any): Observable<any> {
        tableauConfiguration.Config.DisplayName =  tableauConfiguration.DisplayName;
        return this._http.post(`${this.tableauUrlServices}/Tableau-configuration`, tableauConfiguration.Config);
    }

    saveReportConfig(reportConfiguration: any): Observable<any> {
        reportConfiguration.Config.DisplayName =  reportConfiguration.DisplayName;
        return this._http.post(`${this.tableauUrlServices}/tableau-report`, reportConfiguration.Config);
    }
}